export default __webpack_public_path__ + "static/media/mailbox.709310b8.svg";